//hooks/useSortedRecipes.js
import { useContext, useMemo } from "react";
import { MarkedRecipeContext } from "../../contexts/MarkedRecipesContext";
import { RecipeContext } from "../../contexts/RecipeContext";
import { UserContext } from "../../contexts/UserContext";

const useSortedRecipes = () => {
  const { recipes } = useContext(RecipeContext);
  const { markedRecipeIds = [] } = useContext(MarkedRecipeContext) ?? {};
  const { user } = useContext(UserContext);
  const userId = user?.uid || null;

  return useMemo(() => {
    if (!recipes?.length) return [];

    let visibleRecipes = recipes.filter((recipe) => recipe.isPublic || recipe.createdBy === userId);

    if (userId) {
      // User is logged in - filter out original recipes that have been copied
      const copiedFromIds = new Set(visibleRecipes.map((recipe) => recipe.copiedFrom).filter(Boolean));
      visibleRecipes = visibleRecipes.filter((recipe) => !copiedFromIds.has(recipe.id));
    }

    if (!markedRecipeIds.length) return visibleRecipes;

    return visibleRecipes.sort((a, b) => {
      const getPriority = (recipe) => {
        if (markedRecipeIds.includes(recipe.id)) return 1; // Favorite recipes first
        if (recipe.createdBy === userId) return 2; // User-created recipes next
        return 3; // All other recipes
      };

      return getPriority(a) - getPriority(b);
    });
  }, [recipes, markedRecipeIds, userId]);
};

export default useSortedRecipes;
